import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["id", "isEnabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cast, getRoot, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const getCompanyTeamMembersAsync = createAsync(body => {
  return async function getCompanyTeamMembers(options) {
    const teamMembersIds = await api.TeamMembers.getCompanyTeamMembers(body, options);
    const accountIds = [];
    teamMembersIds.response.map(item => accountIds.push(item.accountId));
    const teamMembersProfiles = await api.Account.getUsersProfiles({
      accountIds
    }, options);
    if (teamMembersProfiles !== null && teamMembersProfiles !== void 0 && teamMembersProfiles.isSuccessful) {
      const totalRespData = teamMembersProfiles.response.map(item => {
        const id = item.id,
          isEnabled = item.isEnabled,
          rest = _objectWithoutProperties(item, _excluded);
        const teamMemberId = teamMembersIds.response.find(tmItem => tmItem.accountId === id);
        return _objectSpread(_objectSpread({}, rest), {}, {
          accountId: id,
          id: teamMemberId.id,
          isEnabled: teamMemberId.isEnabled
        });
      });
      this.setCompanyTeamMembers(totalRespData);
      getRoot(this).addNewProperty.setTeammembers(totalRespData);
      if (body !== null && body !== void 0 && body.returnCompleteDataObj) {
        return {
          isSuccessful: true,
          response: totalRespData
        };
      }
    }
    return teamMembersProfiles;
  };
});
const createNewTeamMemberAsync = createAsync(body => {
  return async function createNewTeamMember(options) {
    const resp = await api.TeamMembers.createNewTeamMember(body, options);
    return resp;
  };
});
const disableTeamMemberAsync = createAsync(body => {
  return async function disableTeamMember(options) {
    const resp = await api.TeamMembers.disableTeamMember(body, options);
    return resp;
  };
});
const enableTeamMemberAsync = createAsync(body => {
  return async function enableTeamMember(options) {
    const resp = await api.TeamMembers.enableTeamMember(body, options);
    return resp;
  };
});
const deleteTeamMemberAsync = createAsync(body => {
  return async function deleteTeamMember(options) {
    const resp = await api.TeamMembers.deleteTeamMember(body, options);
    return resp;
  };
});
const getCompanyTeamMembersAggregateAsync = createAsync(() => {
  return async function getCompanyTeamMembersAggregate(options) {
    const resp = await api.TeamMembers.getCompanyTeamMembersAggregate(options);
    return resp;
  };
});
const CompanyTeamMember = types.model({
  accountCode: types.string,
  accountId: types.string,
  email: types.maybeNull(types.string),
  emailConfirmed: types.boolean,
  firstName: types.string,
  id: types.string,
  lastName: types.string,
  newEmail: types.maybeNull(types.string),
  phone: types.maybeNull(types.string),
  portalAccessDateOnly: types.maybeNull(types.string),
  userRole: types.string,
  username: types.string,
  isEnabled: types.boolean
});
const CompanyTeamMemberAggregateItem = types.model({
  teamMemberId: types.string,
  accountId: types.string,
  username: types.string,
  firstName: types.string,
  lastName: types.string,
  phone: types.string,
  email: types.string,
  newEmail: types.string,
  userRole: types.string,
  // Enum -  NonSpecified, LivableSuperAdmin, LivableAdmin, PropertyManagerAccountHolder, PropertyManagerRegular, Resident,
  emailConfirmed: types.boolean,
  accountCode: types.string,
  isEnabled: types.boolean,
  portalAccessDateOnly: types.maybeNull(types.string) // "2024-09-08"
});
const TeamMembersStore = types.model('TeamMembersStore', {
  getCompanyTeamMembersAsync,
  createNewTeamMemberAsync,
  disableTeamMemberAsync,
  enableTeamMemberAsync,
  getCompanyTeamMembersAggregateAsync,
  deleteTeamMemberAsync,
  companyTeamMembers: types.optional(types.array(CompanyTeamMember), []),
  companyTeamMembersAggregate: types.optional(types.array(CompanyTeamMemberAggregateItem), [])
}).actions(store => {
  return {
    setCompanyTeamMembers(data) {
      try {
        store.companyTeamMembers = cast([]);
        store.companyTeamMembers = cast(data);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    getTeamMemberByAccountId(accountId) {
      try {
        return store.companyTeamMembers.find(item => item.accountId === accountId);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    getTeamMember() {
      let isFormer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      try {
        if (isFormer) {
          return store.companyTeamMembers.filter(item => item.isEnabled === false);
        } else {
          return store.companyTeamMembers.filter(item => !!item.isEnabled);
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});
export const teamMembers = types.optional(TeamMembersStore, {});